export const GET_ICEPACKS_FILLED = 'icepacks-filled/GET_ICEPACKS_FILLED';
export const getIcepacksFilledAction = payload => ({
	type: GET_ICEPACKS_FILLED,
	payload,
});

export const SET_ICEPACKS_FILLED = 'icepacks-filled/SET_ICEPACKS_FILLED';
export const setIcepacksFilledAction = payload => ({
	type: SET_ICEPACKS_FILLED,
	payload,
});

export const SET_IS_ICEPACKS_FILLED_LOADING = 'icepacks-filled/SET_IS_ICEPACKS_FILLED_LOADING';
export const setIsIcepacksFilledLoadingAction = payload => ({
	type: SET_IS_ICEPACKS_FILLED_LOADING,
	payload,
});

export const GET_ICEPACKS_FILLERS = 'icepacks-filled/GET_ICEPACKS_FILLERS';
export const getIcepacksFillersAction = () => ({
	type: GET_ICEPACKS_FILLERS,
});

export const SET_ICEPACKS_FILLERS = 'icepacks-filled/SET_ICEPACKS_FILLERS';
export const setIcepacksFillersAction = payload => ({
	type: SET_ICEPACKS_FILLERS,
	payload,
});

export const SET_IS_ICEPACKS_FILLERS_LOADING = 'icepacks-filled/SET_IS_ICEPACKS_FILLERS_LOADING';
export const setIsIcepacksFillersLoadingAction = payload => ({
	type: SET_IS_ICEPACKS_FILLERS_LOADING,
	payload,
});

export const GET_ICEPACKS_STATES = 'icepacks-filled/GET_ICEPACKS_STATES';
export const getIcepacksStatesAction = () => ({
	type: GET_ICEPACKS_STATES,
});

export const SET_ICEPACKS_STATES = 'icepacks-filled/SET_ICEPACKS_STATES';
export const setIcepacksStatesAction = payload => ({
	type: SET_ICEPACKS_STATES,
	payload,
});

export const SET_IS_ICEPACKS_STATES_LOADING = 'icepacks-filled/SET_IS_ICEPACKS_STATES_LOADING';
export const setIsIcepacksStatesLoadingAction = payload => ({
	type: SET_IS_ICEPACKS_STATES_LOADING,
	payload,
});

export const GET_MODES = 'icepacks-filled/GET_MODES';
export const getModesAction = () => ({
	type: GET_MODES,
});

export const SET_MODES = 'icepacks-filled/SET_MODES';
export const setModesAction = payload => ({
	type: SET_MODES,
	payload,
});

export const SET_IS_MODES_LOADING = 'icepacks-filled/SET_IS_MODES_LOADING';
export const setIsModesLoadingAction = payload => ({
	type: SET_IS_MODES_LOADING,
	payload,
});

export const SET_PAGINATION = 'icepacks-filled/SET_PAGINATION';
export const setPaginationAction = payload => ({
	type: SET_PAGINATION,
	payload,
});

export const RESET_STATE = 'icepacks-filled/RESET_STATE';
export const resetStateAction = () => ({
	type: RESET_STATE,
});
